// src/services/planLimits.js

const LIMITES_PADRAO = {
  basico:  { max_clientes: 15,   max_os: 20,   max_estoque: 30 },
  premium: { max_clientes: 9999, max_os: 9999, max_estoque: 9999 },
};

export function getLimitePlano(planoKey) {
  try {
    const saved = localStorage.getItem("planos_config_central") || localStorage.getItem("admin_planos_config");
    if (saved) {
      const planos = JSON.parse(saved);
      const p = planos.find(x => x.id === planoKey);
      if (p) return {
        max_clientes: Number(p.max_clientes) || LIMITES_PADRAO[planoKey]?.max_clientes || 9999,
        max_os:       Number(p.max_os)       || LIMITES_PADRAO[planoKey]?.max_os       || 9999,
        max_estoque:  Number(p.max_estoque)  || LIMITES_PADRAO[planoKey]?.max_estoque  || 9999,
      };
    }
  } catch {}
  return LIMITES_PADRAO[planoKey] || { max_clientes: 9999, max_os: 9999, max_estoque: 9999 };
}

export function getPlanoAtual() {
  return ((sessionStorage.getItem("plano")||localStorage.getItem("plano")) || "basico").toLowerCase();
}

export function getFeaturesLiberadas() {
  try {
    const tenantId = (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1";
    const key = "dev_features_liberadas_tenant_" + tenantId;
    const saved = localStorage.getItem(key);
    if (saved) return JSON.parse(saved);
  } catch {}
  return [];
}

export function setFeaturesLiberadas(tenantId, features) {
  try {
    const key = "dev_features_liberadas_tenant_" + tenantId;
    localStorage.setItem(key, JSON.stringify(features));
  } catch {}
}

export function temFeature(featureKey) {
  const plano = getPlanoAtual();
  if (plano === "premium") return true;
  const liberadas = getFeaturesLiberadas();
  return liberadas.includes(featureKey);
}

// O plano "Profissional" foi descontinuado (auditoria de 18/08/2026) -- os
// recursos que eram exclusivos dele (modelo de orcamento estilizado, logo no
// orcamento, tipos extras) passaram a fazer parte do Premium, junto com o
// que ja era exclusivo do Premium (fundo personalizado, relatorio HTML).
// IMPORTANTE: manter esta lista sincronizada com FEATURES_CATALOGO em
// admin-panel/src/pages/ConfigurarLicenca.js (mesmos 7 ids) -- auditoria de
// 18/08/2026 encontrou "checklist" presente so no admin-panel, ausente
// aqui, e sem nenhuma checagem real em lugar nenhum do frontend (o toggle
// existia mas nao bloqueava nada). Os dois catalogos vivem em builds
// separados (nao ha pacote compartilhado entre frontend/ e admin-panel/),
// entao a sincronizacao e manual -- ao adicionar/remover uma feature aqui,
// espelhar la tambem.
export const CATALOGO_FEATURES = [
  { id: "orcamento_profissional", label: "Modelo de Orcamento Profissional", plano: "premium", desc: "Habilita modelo visual avancado no orcamento" },
  { id: "orcamento_premium",      label: "Modelo de Orcamento Premium",      plano: "premium", desc: "Habilita modelo premium com fundo personalizado" },
  { id: "relatorio_html",         label: "Relatorio HTML Completo",           plano: "premium", desc: "Export de relatorio com graficos e dashboard" },
  { id: "logo_orcamento",         label: "Logo no Orcamento",                plano: "premium", desc: "Permite adicionar logo da empresa no orcamento" },
  { id: "fundo_personalizado",    label: "Fundo Personalizado no Orcamento", plano: "premium", desc: "Cor, gradiente ou imagem de fundo no orcamento" },
  { id: "tipos_orcamento_extras", label: "Tipos de Orcamento Extras",        plano: "premium", desc: "Cadastrar tipos customizados de orcamento" },
  { id: "checklist",              label: "Checklist de Entrada de Veiculo",  plano: "premium", desc: "Inspecao de entrada com avarias, fotos e marcacoes" },
];
